import { render, staticRenderFns } from "./UploadArea.vue?vue&type=template&id=4c2b7503&scoped=true&"
import script from "./UploadArea.vue?vue&type=script&lang=js&"
export * from "./UploadArea.vue?vue&type=script&lang=js&"
import style0 from "./UploadArea.vue?vue&type=style&index=0&id=4c2b7503&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2b7503",
  null
  
)

export default component.exports